//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const CredentialsPanel = lazy(() => import('./CredentialsPanel'));
export const DeviceListPanel = lazy(() => import('./DeviceListPanel'));
export const IdentityPanel = lazy(() => import('./IdentityPanel'));
export const KeyringPanel = lazy(() => import('./KeyringPanel'));
